"use client";

import { createContext, useContext } from "react";

import type { AppUser } from "@/lib/types/next-auth";

type AuthContextValue = {
  user: AppUser;
  /** SSR session token - fallback when client NextAuth hydration is delayed or fails */
  serverAccessToken?: string;
};

const AuthContext = createContext<AuthContextValue | null>(null);

export const useAuth = () => useContext(AuthContext)?.user ?? null;

export const useServerAccessToken = () =>
  useContext(AuthContext)?.serverAccessToken;

export function AuthProvider({
  user,
  accessToken,
  children,
}: {
  user: AppUser;
  accessToken?: string;
  children: React.ReactNode;
}) {
  return (
    <AuthContext.Provider value={{ user, serverAccessToken: accessToken }}>
      {children}
    </AuthContext.Provider>
  );
}
